import React from 'react';
import { TitleFieldProps } from '@rjsf/utils';
import { Divider } from '@mui/material';

const CustomTitleFieldTemplate = ({ title, required }: TitleFieldProps) => {
  return (
    <>
    <h3 style={{ fontSize: '1rem', margin: '10px 0' }}>
      {title} {required ? '*' : null}
    </h3>
    <Divider />
    </>

  );
};

export default CustomTitleFieldTemplate;
